import { Component, OnDestroy, OnInit } from "@angular/core";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { DataService_Staff_Notifications } from "./shared/data.service";
import { PersonRegisteredUsersRequest } from "./shared/person-registered-users-request";
import { PortalNotificationQueueSendMessageRequest } from "./shared/portal-notification-queue-send-message-request";
import { ConfirmationService } from "primeng/api";

@Component({
	selector: "app-staff-notifications",
	templateUrl: "./staff-notifications.component.html",
	styleUrls: ["./staff-notifications.component.css"],
})
export class StaffNotificationsComponent implements OnInit, OnDestroy {
	constructor(
		private personselectorService: PersonSelectorService,
		private dataService: DataService_Staff_Notifications,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			this.loadRegisteredUsers();
		});
	}

	ngOnDestroy(): void {
		this.subscriptionPersonSelect.unsubscribe();
	}

	////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////

	subscriptionPersonSelect: any;
	SelectedPerson: any;

	Message: string = "";

	RegUserLoading: boolean = true;
	Processing: boolean = false;

	HasUserAccount: boolean = false;
	ShowInfo: boolean = false;

	ErrorMessage: string = "";

	////////////////////////////////////////////////////

	////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////

	loadRegisteredUsers() {
		this.HasUserAccount = false;

		if (this.SelectedPerson == undefined || this.SelectedPerson.PersonID == undefined || this.SelectedPerson.PersonID <= 0) {
			return;
		}

		var parms: PersonRegisteredUsersRequest = {
			Token: "", // Filled in by server
			PersonID: this.SelectedPerson.PersonID,
			Domain: "", // Filled in by server
			RegAppTypeID: 3, // Staff App
		};

		this.RegUserLoading = true;

		var result = this.dataService.PersonRegisteredUsersSelectList(parms);
		result.subscribe(
			(response: any) => {
				if (response != undefined && response.length > 0) {
					this.HasUserAccount = true;
				}

				this.RegUserLoading = false;
			},
			(error) => {
				this.RegUserLoading = false;
			}
		);
	}

	////////////////////////////////////////////////////

	////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////

	onSend() {
		this.ErrorMessage = "";

		if (this.SelectedPerson == undefined || this.SelectedPerson.PersonID == undefined || this.SelectedPerson.PersonID < 0) {
			this.ErrorMessage = "Select a staff memeber";
			return;
		}

		if (this.HasUserAccount == false) {
			this.ErrorMessage = "Selected staff memeber doesn't have the Staff Portal App installed";
		}

		if (this.Message == undefined || this.Message == "") {
			this.ErrorMessage = "Enter a message to send";
			return;
		}

		var parms: PortalNotificationQueueSendMessageRequest = {
			PersonID: this.SelectedPerson.PersonID,
			PortalNotificationTypeID: 300,
			ContentText: this.Message,
			Misc_Type: 1,
			Misc1_INT: -1,
			Misc2_INT: -1,
			Misc3_INT: -1,
			Misc1_VARCHAR: "",
			Misc2_VARCHAR: "",
			Misc3_VARCHAR: "",
			Misc1_DT: "",
			Misc2_DT: "",
			Misc3_DT: "",
		};

		this.Processing = true;

		var result = this.dataService.PortalNotificationQueueSendMessage(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "staffnotify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Message was sent successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.Message = "";
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "staffnotify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not send the message: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onToggleInfo() {
		this.ShowInfo = !this.ShowInfo;
	}

	////////////////////////////////////////////////////

	////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////

	IsLoading() {
		return this.RegUserLoading == true || this.Processing == true;
	}

	////////////////////////////////////////////////////
}
